import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, XCircle } from 'lucide-react';
export function PainPoints() {
  return <section className="py-20 bg-white text-gray-800" data-id="element-83">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-84">
        {/* Pain Points Intro */}
        <div className="text-center mb-16" data-id="element-85">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0F172A] mb-6" data-id="element-86">
            Profe de educación física… <br data-id="element-87" />
            <span className="text-[#DC2626]" data-id="element-88">¿esto te resulta familiar?</span>
          </h2>

          <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-89">
            Llegás a casa cansado/a. Sabés que mañana tenés clases. Y otra vez
            aparece lo mismo:
          </p>

          <div className="bg-red-50 border-l-4 border-[#DC2626] p-6 md:p-8 rounded-r-lg shadow-sm text-left mx-auto max-w-2xl" data-id="element-90">
            <ul className="space-y-4" data-id="element-91">
              {['Improvisar actividades', 'Repetir juegos que ya no motivan', 'Armar clases “como se puede”', 'Evaluar sin criterios claros', 'Perder horas planificando desde cero'].map((point, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="flex items-start gap-3 text-lg font-medium text-gray-800" data-id="element-92">
                  <XCircle className="w-6 h-6 text-[#DC2626] flex-shrink-0 mt-0.5" data-id="element-93" />
                  <span data-id="element-94">{point}</span>
                </motion.li>)}
            </ul>
          </div>

          <div className="mt-10 space-y-4" data-id="element-95">
            <p className="text-xl font-semibold text-gray-700" data-id="element-96">
              No es falta de ganas. No es falta de compromiso.
            </p>
            <p className="text-2xl font-bold text-[#1B5E20] bg-green-50 inline-block px-6 py-2 rounded-full" data-id="element-97">
              👉 Es falta de un sistema claro y listo.
            </p>
          </div>
        </div>

        {/* Problem Amplification */}
        <div className="bg-[#0F172A] text-white rounded-2xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-98">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#1B5E20] rounded-full filter blur-3xl opacity-20 -translate-y-1/2 translate-x-1/2" data-id="element-99"></div>

          <div className="relative z-10 text-center" data-id="element-100">
            <h3 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-101">
              El problema no es dar Educación Física <br data-id="element-102" />
              <span className="text-[#F59E0B]" data-id="element-103">
                El problema es tener que inventarlo todo cada semana
              </span>
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left max-w-3xl mx-auto mb-8" data-id="element-104">
              <div className="space-y-3" data-id="element-105">
                <p className="font-semibold text-gray-300 uppercase text-sm tracking-wider" data-id="element-106">
                  Educación Física exige:
                </p>
                {['Variedad', 'Organización', 'Adaptación al espacio'].map((req, i) => <div key={i} className="flex items-center gap-2" data-id="element-107">
                      <AlertCircle className="w-5 h-5 text-[#F59E0B]" data-id="element-108" />
                      <span data-id="element-109">{req}</span>
                    </div>)}
              </div>
              <div className="space-y-3 md:pt-8" data-id="element-110">
                {['Actividades que funcionen', 'Evaluaciones justificables'].map((req, i) => <div key={i} className="flex items-center gap-2" data-id="element-111">
                    <AlertCircle className="w-5 h-5 text-[#F59E0B]" data-id="element-112" />
                    <span data-id="element-113">{req}</span>
                  </div>)}
              </div>
            </div>

            <div className="border-t border-gray-700 pt-8" data-id="element-114">
              <p className="text-xl md:text-2xl font-medium" data-id="element-115">
                Y nadie te dio una herramienta real para eso. <br data-id="element-116" />
                <span className="font-black text-white text-3xl mt-2 block" data-id="element-117">
                  Hasta ahora.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}